(function () {
    const citationContentEl = document.querySelector('.citation-content');
    const mjxContainer = document.querySelector('mjx-container');

    if (citationContentEl) {
        if (mjxContainer) {
            UX.utils.fallbackImageViewer();
        } else {
            UX.utils.mutationObserver(
                'mjx-container',
                {childList: true, subtree: true},
                UX.utils.fallbackImageViewer,
                null,
                true
            );
        }
    }
})();
